import { LoadableAfterPaint } from '@confluence/loadable';

export const DraftLozenge = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-DraftLozenge" */ './DraftLozenge.tsx'))
			.DraftLozenge,
});
